'use client';

import { c as _c } from "react/compiler-runtime";
import { Modal } from '@7f-ui/components/modal/modal';
import { trackCtaSelection } from '@feat/feat-tracking/cta';
import { useState } from 'react';
import { useExperienceOptions } from '../_hooks/use-app-experience-options';
import { getSelectionFromFilter, initSelectedOptions } from '../_lib/experience-booking-utils';
import type { ExperienceFilter } from '../_lib/experience-state-types';
import { useExperienceFilterContext } from './app-experience-filter-provider';
import { AppVariantSelect } from './app-variant-select';
type AppVariantModalContentProps = {
  onSubmit?: (filter: ExperienceFilter) => Promise<void> | void;
  onClose: () => void;
};
function AppVariantModalContent(t0) {
  const $ = _c(17);
  const {
    onSubmit,
    onClose
  } = t0;
  const {
    filter,
    setFilter,
    variants
  } = useExperienceFilterContext();
  const [selectedVariantId, setSelectedVariantId] = useState(filter.selectedVariant ?? undefined);
  const {
    getVariantOptions
  } = useExperienceOptions(variants);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = variantId => {
      setSelectedVariantId(variantId);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleVariantChange = t1;
  let t2;
  if ($[1] !== filter || $[2] !== getVariantOptions || $[3] !== onClose || $[4] !== onSubmit || $[5] !== selectedVariantId || $[6] !== setFilter || $[7] !== variants) {
    t2 = () => {
      if (!selectedVariantId) {
        return;
      }
      const variantHasChanged = selectedVariantId !== filter.selectedVariant;
      const updatedFilter = variantHasChanged ? {
        ...filter,
        selectedVariant: selectedVariantId,
        selectedOptions: initSelectedOptions(getVariantOptions(selectedVariantId) ?? [])
      } : filter;
      if (variantHasChanged) {
        const selection = getSelectionFromFilter(updatedFilter, variants);
        trackCtaSelection("take over - option", {
          selection,
          type: "experience"
        });
        setFilter(updatedFilter);
      }
      if (onSubmit) {
        onSubmit(updatedFilter);
        return;
      }
      onClose();
    };
    $[1] = filter;
    $[2] = getVariantOptions;
    $[3] = onClose;
    $[4] = onSubmit;
    $[5] = selectedVariantId;
    $[6] = setFilter;
    $[7] = variants;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleSubmit = t2;
  let t3;
  if ($[9] !== handleSubmit) {
    t3 = () => <Modal.Footer><Modal.Footer.Actions><Modal.Footer.Button onClick={handleSubmit}>Übernehmen</Modal.Footer.Button></Modal.Footer.Actions></Modal.Footer>;
    $[9] = handleSubmit;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== selectedVariantId || $[12] !== variants) {
    t4 = <AppVariantSelect variants={variants} initialSelectedVariant={selectedVariantId} onChange={handleVariantChange} />;
    $[11] = selectedVariantId;
    $[12] = variants;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <Modal.Content renderFooter={t3}>{t4}</Modal.Content>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
type AppVariantModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (filter: ExperienceFilter) => Promise<void> | void;
};
export function AppVariantModal(t0) {
  const $ = _c(11);
  let config;
  let isOpen;
  let onClose;
  if ($[0] !== t0) {
    ({
      isOpen,
      onClose,
      ...config
    } = t0);
    $[0] = t0;
    $[1] = config;
    $[2] = isOpen;
    $[3] = onClose;
  } else {
    config = $[1];
    isOpen = $[2];
    onClose = $[3];
  }
  let t1;
  if ($[4] !== config || $[5] !== onClose) {
    t1 = props => <><Modal.Header onClose={onClose}>Option wählen</Modal.Header><AppVariantModalContent {...props} {...config} /></>;
    $[4] = config;
    $[5] = onClose;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== isOpen || $[8] !== onClose || $[9] !== t1) {
    t2 = <Modal isOpen={isOpen} onClose={onClose}>{t1}</Modal>;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}